import React from 'react'
import type { MoteLogoProps } from '@mote/assets/logo'
import { MoteLogo } from '@mote/assets/logo'
import type { CommonButtonProps } from './Common'
import { CommonButton } from './Common'

export interface RecordButtonProps
  extends Pick<CommonButtonProps, 'onClick'>,
    Pick<MoteLogoProps, 'isAnimated' | 'dropShadow'> {}

export function RecordButton(props: RecordButtonProps): JSX.Element {
  return (
    <CommonButton
      size={'l'}
      id={'record-button'}
      text={'Record'}
      onClick={props.onClick}
      ariaLabel={'record'}
    >
      <MoteLogo
        size={96}
        scale={1.1}
        isAnimated={props.isAnimated}
        dropShadow={props.dropShadow}
      />
    </CommonButton>
  )
}
